'use strict';
angular.module('signedRankModule', [])
    . controller('signedRankCtrl', signedRankCtrl);
signedRankCtrl.$inject = ['$scope', '$modalInstance', 'rankParams', 'trsHttpService', 'modalDialog'];

/**
 * [signedRankCtrl description]
 *
 * @param {[type]} $scope   [$scope description]
 * @param {[type]} $modalInstance   [$modalInstance description]
 * @param {[type]} rankParams   [rankParams description]
 * @param {[type]} trsHttpService   [trsHttpService description]
 * @param {[type]} modalDialog   [modalDialog description]
 *
 * @return {[type]}   [return description]
 */
function signedRankCtrl($scope, $modalInstance, rankParams, trsHttpService, modalDialog) {
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
    $scope.confirm = function() {
        if (rankParams.fixpos.indexOf($scope.num) >= 0){
            modalDialog.alertType('排序失败,该位置存在固定位置稿件', '', 'info', false);
            $modalInstance.dismiss();
            return;
        }
        var params = Object.assign({
            ChannelId: rankParams.channelid,
            FromChnlDocId: rankParams.item[0].CHNLDOCID,
            NewOrder: $scope.num
        }, rankParams.params);
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
            .then(function(data) {
                $modalInstance.close('success');
            });
    };
}
